/* src/app/forms/gridview/cardview/cardview.component.scss */
.options {
  display: flex;
  margin: 4px;
}
.content {
  padding-top: 4px;
  padding-right: 4px;
}
.cardview-card {
  background: var(--tem-surface);
  border: 1px solid var(--tem-border);
  border-radius: var(--tem-radius);
  box-shadow: var(--tem-shadow);
  transition: border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
  padding: var(--tem-space-3);
}
.cardview-card:hover {
  border-color: var(--tem-accent);
  box-shadow: 0 4px 14px color-mix(in srgb, var(--tem-ink) 14%, transparent);
}
.post-container {
  align-items: center;
  display: flex;
  width: 100%;
}
.post-thumb {
  float: left;
  padding-left: 10px;
  width: 10%;
}
.post-thumb img {
  display: block;
  max-width: 80px;
  max-height: 60px;
  min-height: 60px;
  min-width: 80px;
  border-radius: var(--tem-radius);
  border: 1px solid var(--tem-border);
  background: var(--tem-surface-2);
  object-fit: contain;
}
.post-content {
  margin-left: 40px;
  width: 100%;
}
.post-title {
  font-weight: 600;
  font-size: var(--tem-fs-lg);
  color: var(--tem-ink);
  margin-bottom: 2px;
}
.item-desc {
  font-size: small;
  margin-left: var(--tem-space-2);
}
.post-complemento {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 70px;
  align-items: center;
  max-width: 300px;
  overflow: auto;
}
/*# sourceMappingURL=cardview.component.css.map */
